module.exports = __webpack_public_path__ + "img/chofu_etc_on.e7649ab8.svg";